import { useMemo } from "react";
import { Chart } from "react-google-charts";
import { useTranslation } from "react-i18next";

export default function OrgChartBasic({ lang = "fa" }) {
  const { t } = useTranslation();
  const data = useMemo(() => {
    const label = (key) => t(`personel.org.${key}`);
    const node = (id, text) => ({
      v: id,
      f: `<div style="padding:8px 10px;font-family:'IranSansRegular',sans-serif;border:1px solid #e5e7eb;border-radius:8px;min-width:120px;display:inline-block;"><div style="font-weight:600;color:#0f172a;margin-bottom:4px;text-align:center">${text}</div></div>`,
    });
    return [
      [{ type: "string", label: "Name" }, { type: "string", label: "Manager" }, { type: "string", label: "ToolTip" }],
      [node("ceo", label("ceo")), "", label("ceo")],
      [node("officeManager", label("officeManager")), "ceo", label("officeManager")],
      [node("rnd", label("rnd")), "ceo", label("rnd")],
      [node("engineering", label("engineering")), "ceo", label("engineering")],
      [node("financeAdmin", label("financeAdmin")), "ceo", label("financeAdmin")],
      [node("itManager", label("itManager")), "engineering", label("itManager")],
      [node("dcsAutomation", label("dcsAutomation")), "engineering", label("dcsAutomation")],
      [node("specialists1", label("specialists")), "itManager", label("specialists")],
      [node("specialists2", label("specialists")), "dcsAutomation", label("specialists")],
    ];
  }, [t]);

  return (
    <div dir={lang === "en" ? "ltr" : "rtl"} style={{ overflowX: "auto" }} className="text-center">
      <Chart chartType="OrgChart" data={data} options={{ allowHtml: true, allowCollapse: true, size: "large" }} width="100%" loader={<div>{lang === "en" ? "Loading chart…" : "در حال بارگذاری نمودار..."}</div>} />
    </div>
  );
}
